export default function goToLoginPage(): void {
  window.location.href = 'api/login'
}
